import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const NavItem = styled(Link)`
  text-decoration: none;
  color: #fff;
  display: inline-block;
  white-space: nowrap;
  margin: 0 1vw;
  transition: all 200ms ease-in;
  position: relative;
  font-weight: bold;

  :after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 0%;
    content: ".";
    color: transparent;
    background: ${props => props.theme.colors.secondary};
    height: 1px;
    transition: all 0.4s ease-in;
  }

  :hover {
    color: ${props => props.theme.colors.accent};
    ::after {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    color: #222;
    padding: 20px 0;
    font-size: 1.5rem;
    z-index: 6;
  }
`

const NavbarLinks = () => {
  return (
    <>
      <NavItem to="/">Home</NavItem>
      <NavItem to="/services">Services</NavItem>
      <NavItem to="/staff">Staff</NavItem>
      <NavItem to="/media">Media</NavItem>
      <NavItem to="/contact">Contact</NavItem>
    </>
  )
}

export default NavbarLinks
